import React, { useState } from 'react';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

  const BACKEND_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BACKEND_URL;

    try {
      const response = await fetch(`${BACKEND_URL}/others/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App-header" id="contact-form" style={{ position: 'relative', top: '0vh' }}>
      <div className="contact-text">
        <h1 className="hero-title">Contact Us</h1>
        <p className="hero-subtitle" style={{ width: "80%" }}>
          Have questions or want to get in touch? Fill out the form below and we'll respond as soon as possible.
        </p>
        <form onSubmit={handleSubmit} className="contact-form-container">
          <input 
            type="text" 
            name="name" 
            placeholder="Name" 
            required 
            className="contact-form-input"
            value={formData.name}
            onChange={handleChange}
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            required 
            className="contact-form-input"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea 
            name="message" 
            placeholder="Please type your message here" 
            required 
            rows="5" 
            className="contact-form-textarea"
            value={formData.message}
            onChange={handleChange}
          />
          <button 
            type="submit" 
            className="button-arrow" 
            style={{ width: 'fit-content' }}
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
